import { computed } from 'vue'
import type { Ref } from 'vue'

export function useRoundness(digistormSettings: Ref<unknown>) {
    const roundness = computed(() => {
        switch (digistormSettings.value?.roundness) {
            case 'rounded':
                return 'soft'
            case 'circular':
                return 'round'
            case 'sharp':
                return 'sharp'
            default:
                return 'subtle'
        }
    })

    const btnRoundness = computed(() => {
        switch (digistormSettings.value?.btnRoundness) {
            case 'rounded':
                return 'soft'
            case 'circular':
                return 'round'
            case 'sharp':
                return 'sharp'
            default:
                return 'default'
        }
    })

    return { roundness, btnRoundness }
}
